import { render, staticRenderFns } from "./ViewBlogHeader.vue?vue&type=template&id=85dff2b6&"
import script from "./ViewBlogHeader.vue?vue&type=script&lang=js&"
export * from "./ViewBlogHeader.vue?vue&type=script&lang=js&"
import style0 from "./ViewBlogHeader.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports